import React from 'react';

import MIcon from 'views/MIcon/MIcon';
import MContainer from 'views/MContainer/MContainer';

import classes from './HomeAgentStatistic.module.scss';
import { BsTag } from 'react-icons/bs';

type Props = {
  title: string;
  value: number;
};

const HomeAgentStatisticView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const fontSize = props.value.toString().length < 4 ? 80 : 240 / props.value.toString().length;

  return (
    <MContainer className={classes['container']}>
      <div className={classes['body']}>
        <div className={classes['title']}>
          <MIcon name={BsTag} className={classes['icon']}></MIcon>
          <span>{props.title}</span>
        </div>
        <div className={classes['content']} style={{ fontSize: fontSize }}>
          {props.value}
        </div>
      </div>
    </MContainer>
  );
};

HomeAgentStatisticView.displayName = 'HomeAgentStatisticView';
HomeAgentStatisticView.defaultProps = {};

export default React.memo(HomeAgentStatisticView);
